export function SwitchNavState() {
	const navBtn = document.querySelector('.js-nav-btn') as HTMLButtonElement,
		navArea = document.querySelector('.js-nav-area') as HTMLElement;
				// navLast = <HTMLAnchorElement>document.querySelector('.js-nav-last');

	if (!navBtn || !navArea) return

	const navClose = () => {
		navBtn.setAttribute('aria-expanded', 'false');
		navArea.setAttribute('aria-hidden', 'true');
		document.body.classList.remove('is-nav');
	}

	navBtn.addEventListener('click', () => {
		const btnState = navBtn.getAttribute('aria-expanded');

		if(btnState === 'false'){
			navBtn.setAttribute('aria-expanded', 'true');
			navArea.setAttribute('aria-hidden', 'false');
			document.body.classList.add('is-nav');
		} else {
			navClose()
		}
	});

	// navLast.addEventListener('focusout', () => {
	// 	navClose()
	// });

	document.body.addEventListener('keyup', (e) => {
		if (e.code === "Escape") {
			navClose()
		}
	});

	document.addEventListener('click', (e) => {
		const target = e.target as HTMLElement;

	  if (!target.closest('.js-nav-btn') && document.body.classList.contains('is-nav')) {
			navClose()
	  }
	});
}
